import { updateItemInCollection } from "directus/src/operations";

export async function createHourlyConfig({ jobId, values }) {
  try {
    const query = {
      fields: ["id", "rate", "currency", "project.project_id"],
    };

    const response = await updateItemInCollection(
      "jobs",
      jobId,
      {
        hourly_job_config: values,
      },
      query
    );
    return response;
  } catch (error) {
    console.error("Error creating hourly config:", error);
    throw error;
  }
}

export async function updateHourlyConfig({ id, values }) {
  try {
    const query = {
      fields: ["id", "rate", "currency"],
    };

    const response = await updateItemInCollection(
      "hourly_job_config",
      id,
      values,
      query
    );
    return response;
  } catch (error) {
    console.error("Error updating hourly config:", error);
    throw error;
  }
}
